(function() {
    'use strict';

    angular.module('remitEventsApp').factory('EventFilter', function($stateParams, $resource, Event, ContractorFilter, Content) {
        return {
            getSortOptions: function(type) {
                return _.filter(
                    [
                        {
                            id: 1,
                            sort: {
                                sortBy: 'publicationDate',
                                order: 'desc'
                            },
                            type: 'other',
                            label: 'remitEventsApp.event.sortOptions.publicationDateDesc'
                        },
                        {
                            id: 2,
                            sort: {
                                sortBy: 'publicationDate',
                                order: 'asc'
                            },
                            type: 'other',
                            label: 'remitEventsApp.event.sortOptions.publicationDateAsc'
                        },
                        {
                            id: 3,
                            sort: {
                                sortBy: 'eventStart',
                                order: 'desc'
                            },
                            label: 'remitEventsApp.event.sortOptions.eventStartDesc'
                        },
                        {
                            id: 4,
                            sort: {
                                sortBy: 'eventStart',
                                order: 'asc'
                            },
                            label: 'remitEventsApp.event.sortOptions.eventStartAsc'
                        }
                    ],
                    function(value) {
                        return (!value.type && !type) || value.type === type || !type;
                    }
                );
            },
            loadAll: function(mode, paginationConfig, eventFilter, sort, callback) {
                var that = this;
                ContractorFilter.promiseConfig().then(function(result) {
                    var config = result;
                    var contractorEic = 'all';
                    var foundContractor = _.find(config, function(contractor) {
                        return contractor.shortName === $stateParams.contractor;
                    });

                    if (!_.isEmpty(foundContractor)) {
                        contractorEic = foundContractor.eicCode;
                    }

                    that._loadEvents(mode, paginationConfig, eventFilter, contractorEic, sort, callback);
                });
            },
            _loadEvents: function(mode, paginationConfig, eventFilter, contractorEic, sort, callback) {
                var queryParams = { mode: mode };
                var sortOption = {
                    sortBy: 'publicationDate',
                    order: 'desc'
                };

                if (sort) {
                    var data = _.find(this.getSortOptions(), function(value) {
                        return value.id === sort.id;
                    });

                    if (data) {
                        sortOption = data.sort;
                    }
                }

                if (contractorEic !== 'all') {
                    eventFilter.contractor = contractorEic;
                } else {
                    delete eventFilter.contractor;
                }

                if (eventFilter.dateFrom) {
                    eventFilter.dateFrom = moment.isMoment(eventFilter.dateFrom)
                        ? eventFilter.dateFrom.format('YYYY/MM/DD HH:mm:ss')
                        : eventFilter.dateFrom;
                }

                if (eventFilter.dateTo) {
                    eventFilter.dateTo = moment.isMoment(eventFilter.dateTo)
                        ? eventFilter.dateTo.endOf('day').format('YYYY/MM/DD HH:mm:ss')
                        : eventFilter.dateTo;
                }

                if (paginationConfig) {
                    queryParams = _.extend(queryParams, {
                        page: paginationConfig.page,
                        size: paginationConfig.size,
                        sortBy: sortOption.sortBy,
                        order: sortOption.order
                    });
                }

                queryParams = _.extend(queryParams, eventFilter);

                Event.query(queryParams, function(result) {
                    callback(result);
                });
            },
            filterRange: function(event, dateFrom, dateTo) {
                if (event.publicationDate) {
                    var inDateRange = true;
                    var publicationDate = moment(event.publicationDate);
                    if (dateFrom) {
                        inDateRange = inDateRange && publicationDate.isSameOrAfter(dateFrom);
                    }
                    if (dateTo) {
                        inDateRange = inDateRange && publicationDate.isSameOrBefore(dateTo);
                    }
                    return inDateRange || this.eventDatesInRange(event, dateFrom, dateTo);
                } else {
                    console.error('Event with id ' + event.id + " doesn't have publicationDate");
                    return false;
                }
            },
            eventDatesInRange: function(event, dateFrom, dateTo) {
                var inDateRange = true;
                if (event.eventStart && dateTo) {
                    var eventStart = moment(event.eventStart);
                    inDateRange = eventStart.isBefore(dateTo);
                }
                if (event.eventStop && dateFrom) {
                    var eventStop = moment(event.eventStop);
                    inDateRange = inDateRange && eventStop.isAfter(dateFrom);
                }

                return inDateRange;
            },
            getSelectedcontractors: function(contractors, stateContractor) {
                return _.map(
                    _.filter(contractors, function(contractor) {
                        return contractor.shortName === stateContractor;
                    }),
                    function(contractor) {
                        return contractor.id;
                    }
                );
            },
            getSelectedEventTypes: function(eventTypes) {
                var selectedEventTypes = _.filter(eventTypes, function(eventType) {
                    return eventType.selected;
                });
                var selectedEventTypeIds = _.map(selectedEventTypes, function(eventType) {
                    return eventType.value;
                });

                return selectedEventTypeIds;
            },
            getAssentNames: function(assentNames) {
                var selectedAssentNames = _.filter(assentNames, function(assentName) {
                    return assentName.selected;
                });

                return _.map(selectedAssentNames, function(assentName) {
                    return assentName.name;
                });
            },
            filterContractors: function(event, eventFilter) {
                return _.isEmpty(eventFilter.contractorIds) || _.contains(eventFilter.contractorIds, event.marketParticipantCode);
            },
            filterEventTypes: function(event, eventFilter) {
                return _.isEmpty(eventFilter.eventTypes) || _.contains(eventFilter.eventTypes, event.eventType);
            },
            getEventFilter: function(dateFrom, dateTo, contractors, eventTypes, dictionaries, stateContractor) {
                return {
                    dateFrom: dateFrom ? moment(dateFrom, 'DD/MM/YYYY').startOf('day') : null,
                    dateTo: dateTo ? moment(dateTo, 'DD/MM/YYYY').endOf('day') : null,
                    contractorIds: this.getSelectedcontractors(contractors, stateContractor),
                    eventTypes: this.getSelectedEventTypes(eventTypes),
                    assentNames: this.getAssentNames(dictionaries.assentNames)
                };
            },
            translateRemarks: function(events, language) {
                _.each(events, function(event) {
                    event.remarksTranslated = language === 'pl' ? event.remarks : event.remarksEN;
                });
                return events;
            },
            translateReasons: function(events, language) {
                _.each(events, function(event) {
                    event.unavailabilityReasonTranslated = language === 'pl' ? event.unavailabilityReason : event.unavailabilityReasonEN;
                });

                return events;
            },
            getEventTypes: function() {
                return [
                    { value: 'PLANNED', selected: false, label: 'remitEventsApp.MriEventType.PLANNED' },
                    { value: 'NOT_PLANNED', selected: false, label: 'remitEventsApp.MriEventType.NOT_PLANNED' }
                ];
            },
            shouldBeShown: function(event) {
                return event.currentVersion;
            },
            contractorsShown: function(contractors) {
                return $stateParams.contractor === 'all' || contractors.length > 1;
            },
            dateRangeChanged: function(lastDateRange, dateFrom, dateTo) {
                return (
                    (_.isEmpty(lastDateRange.dateFrom) && _.isEmpty(lastDateRange.dateTo)) ||
                    dateFrom.isBefore(lastDateRange.dateFrom) ||
                    dateTo.isAfter(lastDateRange.dateTo)
                );
            },
            excelLink: function(eventFilter) {
                var dateFrom = moment(eventFilter.dateFrom, 'YYYY/MM/DD').format('YYYY/MM/DD');
                var dateTo = moment(eventFilter.dateTo, 'YYYY/MM/DD')
                    .clone()
                    .add(1, 'day')
                    .format('YYYY/MM/DD');
                var commodity = Content.getCommodityEnum($stateParams.commodity);
                var link = 'xlsx/' + commodity + '?dateFrom=' + dateFrom + '&dateTo=' + dateTo;

                if (!_.isEmpty(eventFilter.contractorIds)) {
                    link += '&contractors=' + eventFilter.contractorIds.join();
                } else if (['all', 'production', 'information'].indexOf($stateParams.contractor) === -1) {
                    link += '&contractors=' + $stateParams.contractor;
                }
                return link;
            },
            markContractorsSelected: function(contractors, selectedIds) {
                _.each(contractors, function(contractor) {
                    if (_.contains(selectedIds, contractor.id)) {
                        contractor.selected = true;
                    }
                });
            },
            markEventTypesSelected: function(eventTypes, eventTypesSelected) {
                _.each(eventTypes, function(eventType) {
                    if (_.contains(eventTypesSelected, eventType.value)) {
                        eventType.selected = true;
                    }
                });
            },
            markAssentNamesSelected: function(assentNames, selected) {
                _.each(assentNames, function(assentName) {
                    if (_.contains(selected, assentName.name)) {
                        assentName.selected = true;
                    }
                });
            },
            getAssentNamesData: function() {
                return $resource(
                    'api/dictionaries/assentNames',
                    {},
                    {
                        query: {
                            method: 'GET',
                            isArray: true
                        }
                    }
                );
            }
        };
    });
})();
